import React, { useState } from "react";
import "./styles.scss";
import { Button } from "@ts-digital/vrc";
import CreateAccountingYear from "./createAccountingYear";
import accountingYearHomeOne from "../../../assets/img/accounting_year_home_1.png";
import { useIntl } from "react-intl";
import moment from "moment";
import { useDispatch } from "react-redux";
import { createAccountingYearsList } from "../../../store/actions/accountingYears";
import { useNavigate } from "react-router-dom";

const NewAccountingYearPage = ({companyName}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const createAccYearCta = useIntl().formatMessage({id: "accountingYear.createAccYearCta"});
  const [startDate, setStartDate] = useState(moment().startOf("year"));
  const [endDate, setEndDate] = useState(moment().endOf("year"));
	
  return (
    <>
      <div className="accounting-year-page-component">
        <div className="accounting-year-image-left" style={{backgroundImage: `url(${accountingYearHomeOne})`}}></div>
        <CreateAccountingYear 
          companyName={companyName}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      <footer className="accounting-year-page-footer"> 
        <Button 
          kind="primary" 
          size="medium" 
          className="createNewAccYearButton"
          onClick={() => 
            dispatch(createAccountingYearsList(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))).then(res => {
              navigate("/accounting-years-list");
            })
          }
        >
          {createAccYearCta}
        </Button>
      </footer>
    </>
  );
};

export default NewAccountingYearPage;